import store from '@/store'

const fetchWorkFlows = () => {
  store
    .dispatch('operationCalendar/fetchWorkFlows')
}

// eslint-disable-next-line import/prefer-default-export
export { fetchWorkFlows }
